import { useState } from 'react';
import { Plus, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { CompanySettings } from '@/types/firebase';

interface CreateInvoiceButtonProps {
  companySettings?: CompanySettings;
  className?: string;
}

export function CreateInvoiceButton({ companySettings, className = '' }: CreateInvoiceButtonProps) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleCreateInvoice = (type: 'standard' | 'recurring') => {
    setOpen(false);
    navigate(`/app/invoices/new?type=${type}`);
  };

  // If recurring is not enabled, just show a regular button
  const enableRecurring = companySettings?.enableRecurringInvoices;
  
  if (!enableRecurring) {
    return (
      <Button 
        className={`flex items-center gap-2 ${className}`}
        onClick={() => navigate('/app/invoices/new')}
      >
        <Plus className="h-4 w-4" />
        Create Invoice
      </Button>
    );
  }

  // Otherwise, show dropdown with enabled options
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button className={`flex items-center gap-2 ${className}`}>
          <Plus className="h-4 w-4" />
          Create Invoice
          <ChevronDown className="h-4 w-4 ml-1" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => handleCreateInvoice('standard')}>
          Standard Invoice
        </DropdownMenuItem>
        {enableRecurring && (
          <DropdownMenuItem onClick={() => handleCreateInvoice('recurring')}>
            Recurring Invoice
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
} 